import { Event } from '@deltager/organizers/admin/modules/events/create-event/model/event.model';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { EventHeader } from '../model/event-header';
import { EventSetupWizardStep } from '@deltager/organizers/admin/modules/events/create-event/model/event-setup-wizard-step.enum';
import { AccountingSystem } from '@deltager/organizers/admin/shared/models/AccountingSystem';
import { EventSetupError } from '@deltager/organizers/admin/modules/events/create-event/model/event-error.model';
import {
  NesSession,
  NesSessionList,
} from '@deltager/organizers/admin/modules/event-sessions/event-session-calendar/session.model';
import { SessionName } from '@deltager/organizers/admin/modules/event-sessions/event-session-calendar/session.model';

export interface EventSetupState {
  initialEvent: Event;
  createdEvent: Event;
  eventSessions: NesSessionList[];
  editedSession: NesSession;
  sessionNames?: SessionName[];
  currentEventStatus: EventStatus;
  newEvent: boolean;
  existingEvent: boolean;
  error: EventSetupError;
  eventStats: EventHeader;
  currentStep: EventSetupWizardStep;
  accountingSystem?: AccountingSystem;
  popupRepeatingEventId: number | null;
  lastBankAccountId: number;
  totalAmountOfSessions: number;
  masterTotalSubEventsCount?: number;
}

export enum EventStatus {
  initializing = 0,
  initialized = 1,
  creating = 2,
  created = 3,
  edited = 4,
  submitting = 5,
  submitted = 6,
  updating = 7,
  updated = 8,
  error = 9,
  editing = 10,
  createdButWithSessions = 11,
}

export const initialEventSetupState: EventSetupState = {
  initialEvent: null,
  createdEvent: null,
  eventSessions: null,
  sessionNames: null,
  editedSession: null,
  currentEventStatus: EventStatus.initializing,
  newEvent: false,
  error: null,
  existingEvent: false,
  eventStats: null,
  currentStep: EventSetupWizardStep.Unspecified,
  popupRepeatingEventId: null,
  lastBankAccountId: 0,
  totalAmountOfSessions: 0,
  masterTotalSubEventsCount: null,
};

export const eventUpdateProgress = (state: EventSetupState): boolean => {
  return (
    state.currentEventStatus === EventStatus.submitting ||
    state.currentEventStatus === EventStatus.updating ||
    state.currentEventStatus === EventStatus.creating
  );
};

export const submittedEvent = (obs: Observable<EventSetupState>) =>
  obs.pipe(
    filter(
      s =>
        s.currentEventStatus === EventStatus.updated ||
        s.currentEventStatus === EventStatus.submitted ||
        s.currentEventStatus === EventStatus.created,
    ),
    map(s => s.createdEvent),
  );

export const initialEvent = (obs: Observable<Event>) => obs.pipe(take(1));
